define.alias("shared/components/shared/address-fields/suggestions", "calendar/components/shared/address-fields/suggestions");